import { TableUtility } from '@utility/dynamic-table';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useResellerReport } from '../../../Hooks/useResellerReport';
import ResellerTableInitial from './ResellerTableInitial';
import { useCallback, useMemo } from 'react';

const ResellerReportTable = () => {
  const { resellerTableConfig, resellerTableData, initialLoad, searchQuery } = useResellerReport();
  const configuration = {
    generalSettings: {
      enableApiFiltering: false,
      showPagination: true,
    },
    showToolBar: false,
    tableSettings: {
      size: 'small',
      loaderSkeleton: {
        rows: 6,
        bodyCells: 1,
        columns: 10,
      },
      tableConfig: resellerTableConfig,
      tableScrollHeight: '100%',
      paginationConfig: {
        page: 1,
        limit: 10,
        rowsPerPageOptions: [5, 15, 25, 50],
      },

      maxFrozenColumns: {
        desktop: 4,
        tablet: 2,
        mobile: 1,
      },
    },
  };
  const searchArray = useCallback((data, searchTerm) => {
    return data.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, []);

  const filteredData = useMemo(
    () =>
      searchQuery
        ? searchArray(resellerTableData, searchQuery)
        : resellerTableData,
    [searchQuery, resellerTableData, searchArray],
  );
  return (
    <div className="reseller-report-table">
      {initialLoad ? (
        <ResellerTableInitial />
      ) : (
        <TableUtility configuration={configuration} data={filteredData} />
      )}
    </div>
  );
};

export default ResellerReportTable;
